module.exports = __webpack_public_path__ + "static/images/dashboard.0f65d4d93f8b13eedcc0b71bdc360cb8.svg";